import { localized } from '../utils'
import styles from './LabelMeter.module.css'

type Props = {
	value: number
	leftLabel?: string
	rightLabel?: string
}

export function LabelMeter({ value, leftLabel, rightLabel }: Props) {
	const ratio = Math.max(0, Math.min(1, value)) * 100 // Clamp value between 0..1

	return (
		<div className={styles.wrapper}>
			<span className={styles.labelLeft}>{leftLabel}</span>

			<div
				className={styles.container}
				title={ratio ? `${localized.numberFormatFraction1.format(ratio)} %` : undefined}
			>
				<div className={styles.fill} style={{ width: `${ratio}%` }} />
				<div className={styles.center} />
			</div>

			<span className={styles.labelRight}>{rightLabel}</span>
		</div>
	)
}
